import { render, staticRenderFns } from "./ServicePointHeader.vue?vue&type=template&id=4db15490&scoped=true&"
import script from "./ServicePointHeader.vue?vue&type=script&lang=ts&"
export * from "./ServicePointHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointHeader.vue?vue&type=style&index=0&id=4db15490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db15490",
  null
  
)

export default component.exports